"use client";

var __jsx = React.createElement;
import React from "react";
import Header from "../components/header";
import Footer from "../components/footer";
const MuscleBenefitPlatformLayout = _ref => {
  let {
    children,
    headerProps
  } = _ref;
  return __jsx(React.Fragment, null, __jsx(Header, headerProps), children, __jsx(Footer, null));
};
export default MuscleBenefitPlatformLayout;